import React, {useState} from "react";
import {Box, IconButton, Typography} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {useTranslation} from "react-i18next";
import EmailPreviewFrame from "./EmailPreviewFrame";

type EmailTemplatePreviewProps = {
  previewHtml: string | null;
  status: "loading" | "ready" | "error";
  mailSender: string;
  subject: string;
  templateName?: string;
};

export default function EmailTemplatePreview({previewHtml, status, mailSender, subject, templateName}: EmailTemplatePreviewProps): JSX.Element {
  const {t} = useTranslation();
  const [show, setShow] = useState(true);

  return (
    <Box sx={{flex: 2, minWidth: 0, display: "flex", flexDirection: "column", p: 3, gap: 2, minHeight: 0, borderLeft: "1px solid", borderColor: "ornament.dark"}}>
      <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
        <IconButton size="small" sx={{p: 0}} onClick={(): void => setShow(v => !v)}>
          {show
            ? <VisibilityIcon sx={{color: "neutral.main", width: 18, height: 18}} />
            : <VisibilityOffIcon sx={{color: "neutral.main", width: 18, height: 18}} />}
        </IconButton>
        <Typography variant="body2" sx={{fontWeight: "bold", color: "neutral.main"}}>
          {t("email_templates.preview.preview")}
        </Typography>
      </Box>

      {show && (
        <EmailPreviewFrame
          html={previewHtml}
          status={status}
          sender={mailSender || ""}
          subject={subject || ""}
          title={templateName}
          fill
        />
      )}

    </Box>
  );
}
